import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import { colors } from "../../../theme";
import { em } from "../../../utils";

export const Label = styled(({ color, style, large, error, ...props }) => (
  <label {...props} />
))`
  display: block;
  margin: 0;
  font-family: "GT-Walsheim", sans-serif;
  font-weight: 700;
  font-size: ${props => (props.large ? em(12) : em(11))};
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${props => props.color || colors.black};
  margin-bottom: 5px;
  color: ${props => (props.error ? "red" : "black")};
  ${props => props.style};
`;

Label.propTypes = {
  color: PropTypes.string,
  large: PropTypes.bool,
  style: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/Form/Label/Label.js